var L = Object.defineProperty;
var $ = (n, e, t) => e in n ? L(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t;
var g = (n, e, t) => $(n, typeof e != "symbol" ? e + "" : e, t);
var A = Object.defineProperty, S = (n, e, t) => e in n ? A(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, s = (n, e, t) => S(n, typeof e != "symbol" ? e + "" : e, t);
function W() {
  const n = C(), e = R(), t = M(), r = k(), o = N(), a = O();
  let l = h.NONE;
  return e ? l = h.PLASMO : t && (l = h.WXT), {
    frameworkType: l,
    isExtension: n,
    isPlasmo: e,
    isWxt: t,
    isDev: r,
    browser: o,
    platform: a
  };
}
function C() {
  return !!(typeof chrome < "u" && chrome.runtime && chrome.runtime.id || typeof browser < "u" && browser.runtime && browser.runtime.id || typeof window < "u" && window.chrome && window.chrome.runtime && window.chrome.runtime.id);
}
function R() {
  try {
    if (typeof window < "u" && window.plasmo)
      return !0;
    if (typeof require < "u")
      try {
        return require("@plasmohq/storage"), !0;
      } catch {
      }
    if (typeof process < "u" && process.cwd) {
      const n = require("fs"), e = require("path").join(process.cwd(), "plasmo.json");
      if (n.existsSync(e))
        return !0;
    }
    return !1;
  } catch {
    return !1;
  }
}
function M() {
  try {
    if (typeof window < "u" && window.wxt)
      return !0;
    if (typeof process < "u" && process.cwd) {
      const n = require("fs"), e = require("path").join(process.cwd(), "wxt.config.ts");
      if (n.existsSync(e))
        return !0;
    }
    return !1;
  } catch {
    return !1;
  }
}
function k() {
  var n;
  return typeof process < "u" && process.env ? process.env.NODE_ENV === "development" : typeof window < "u" && window.import && window.import.meta ? ((n = window.import.meta.env) == null ? void 0 : n.DEV) === !0 : !1;
}
function N() {
  if (typeof window > "u")
    return null;
  const n = window.navigator.userAgent;
  return n.includes("Chrome") && !n.includes("Edg") ? "chrome" : n.includes("Firefox") ? "firefox" : n.includes("Edg") ? "edge" : n.includes("Safari") && !n.includes("Chrome") ? "safari" : null;
}
function O() {
  if (typeof window > "u")
    return typeof process < "u" ? process.platform : "unknown";
  const n = window.navigator.userAgent;
  return n.includes("Win") ? "windows" : n.includes("Mac") ? "macos" : n.includes("Linux") ? "linux" : n.includes("Android") ? "android" : n.includes("iPhone") || n.includes("iPad") ? "ios" : "unknown";
}
const X = {
  level: k() ? "debug" : "info",
  prefix: "[GitCoffee Browser]",
  enableColors: !0,
  enableTimestamps: !0
};
class U {
  constructor(e = {}) {
    s(this, "config"), this.config = {
      ...X,
      ...e
    };
  }
  /**
   * 输出调试级别日志
   * @param message 日志消息
   * @param ...args 额外参数
   */
  debug(e, ...t) {
    this.log("debug", e, ...t);
  }
  /**
   * 输出信息级别日志
   * @param message 日志消息
   * @param ...args 额外参数
   */
  info(e, ...t) {
    this.log("info", e, ...t);
  }
  /**
   * 输出警告级别日志
   * @param message 日志消息
   * @param ...args 额外参数
   */
  warn(e, ...t) {
    this.log("warn", e, ...t);
  }
  /**
   * 输出错误级别日志
   * @param message 日志消息
   * @param ...args 额外参数
   */
  error(e, ...t) {
    this.log("error", e, ...t);
  }
  /**
   * 通用日志输出方法
   * @param level 日志级别
   * @param message 日志消息
   * @param ...args 额外参数
   */
  log(e, t, ...r) {
    if (!this.shouldLog(e))
      return;
    const o = this.buildLogMessage(e, t);
    switch (e) {
      case "debug":
        console.debug(o, ...r);
        break;
      case "info":
        console.info(o, ...r);
        break;
      case "warn":
        console.warn(o, ...r);
        break;
      case "error":
        console.error(o, ...r);
        break;
    }
  }
  /**
   * 检查是否应该输出该级别的日志
   * @param level 日志级别
   * @returns 是否应该输出
   */
  shouldLog(e) {
    const t = [
      "debug",
      "info",
      "warn",
      "error",
      "off"
      /* OFF */
    ];
    return t.indexOf(e) >= t.indexOf(this.config.level);
  }
  /**
   * 构建日志消息
   * @param level 日志级别
   * @param message 日志消息
   * @returns 构建后的日志消息
   */
  buildLogMessage(e, t) {
    let r = [];
    if (this.config.prefix && r.push(this.config.prefix), this.config.enableTimestamps) {
      const o = (/* @__PURE__ */ new Date()).toISOString();
      r.push(`[${o}]`);
    }
    return r.push(`[${e.toUpperCase()}]`), r.push(t), r.join(" ");
  }
  /**
   * 更新日志配置
   * @param config 新的配置
   */
  updateConfig(e) {
    this.config = {
      ...this.config,
      ...e
    };
  }
  /**
   * 获取当前日志配置
   * @returns 当前日志配置
   */
  getConfig() {
    return { ...this.config };
  }
}
const i = new U();
i.debug.bind(i);
i.info.bind(i);
i.warn.bind(i);
i.error.bind(i);
class I {
  constructor() {
    s(this, "type", h.PLASMO), s(this, "name", "Plasmo Framework"), s(this, "version", "1.0.0"), s(this, "initialized", !1);
  }
  async initialize() {
    if (!this.initialized)
      try {
        if (i.info("Initializing Plasmo framework..."), !this.isAvailable())
          throw new Error("Plasmo framework not available");
        this.initialized = !0, i.info("Plasmo framework initialized successfully");
      } catch (e) {
        throw i.error("Failed to initialize Plasmo framework:", e), e;
      }
  }
  isAvailable() {
    try {
      if (typeof window < "u" && window.plasmo || typeof chrome < "u" && chrome.runtime && chrome.runtime.id)
        return !0;
      try {
        if (typeof require < "u")
          return !0;
      } catch {
      }
      return !1;
    } catch (e) {
      return i.error("Error checking Plasmo availability:", e), !1;
    }
  }
  getAPI() {
    try {
      return {
        storage: chrome == null ? void 0 : chrome.storage,
        runtime: chrome == null ? void 0 : chrome.runtime,
        tabs: chrome == null ? void 0 : chrome.tabs,
        windows: chrome == null ? void 0 : chrome.windows
      };
    } catch (e) {
      return i.error("Error getting Plasmo API:", e), {};
    }
  }
  async cleanup() {
    try {
      i.info("Cleaning up Plasmo framework..."), this.initialized = !1, i.info("Plasmo framework cleaned up successfully");
    } catch (e) {
      i.error("Failed to cleanup Plasmo framework:", e);
    }
  }
}
class F {
  constructor() {
    s(this, "type", h.WXT), s(this, "name", "WXT Framework"), s(this, "version", "1.0.0"), s(this, "initialized", !1);
  }
  async initialize() {
    if (!this.initialized)
      try {
        if (i.info("Initializing WXT framework..."), !this.isAvailable())
          throw new Error("WXT framework not available");
        this.initialized = !0, i.info("WXT framework initialized successfully");
      } catch (e) {
        throw i.error("Failed to initialize WXT framework:", e), e;
      }
  }
  isAvailable() {
    try {
      if (typeof window < "u" && window.wxt || typeof chrome < "u" && chrome.runtime && chrome.runtime.id)
        return !0;
      try {
        if (typeof require < "u")
          return !0;
      } catch {
      }
      return !1;
    } catch (e) {
      return i.error("Error checking WXT availability:", e), !1;
    }
  }
  getAPI() {
    try {
      return {
        storage: chrome == null ? void 0 : chrome.storage,
        runtime: chrome == null ? void 0 : chrome.runtime,
        tabs: chrome == null ? void 0 : chrome.tabs,
        windows: chrome == null ? void 0 : chrome.windows
      };
    } catch (e) {
      return i.error("Error getting WXT API:", e), {};
    }
  }
  async cleanup() {
    try {
      i.info("Cleaning up WXT framework..."), this.initialized = !1, i.info("WXT framework cleaned up successfully");
    } catch (e) {
      i.error("Failed to cleanup WXT framework:", e);
    }
  }
}
var h = /* @__PURE__ */ ((n) => (n.PLASMO = "plasmo", n.WXT = "wxt", n.NONE = "none", n))(h || {});
const z = class w {
  constructor() {
    s(this, "currentFramework", null), s(this, "initialized", !1);
  }
  static getInstance() {
    return w.instance || (w.instance = new w()), w.instance;
  }
  // 初始化框架
  async initialize() {
    if (this.initialized && this.currentFramework)
      return this.currentFramework;
    try {
      i.info("Initializing browser framework...");
      const e = W();
      return i.info("Detected environment:", e), e.frameworkType === "plasmo" ? this.currentFramework = new I() : e.frameworkType === "wxt" ? this.currentFramework = new F() : this.currentFramework = this.createNoneFramework(), this.currentFramework && (await this.currentFramework.initialize(), i.info(`Initialized framework: ${this.currentFramework.name} (${this.currentFramework.type})`)), this.initialized = !0, this.currentFramework;
    } catch (e) {
      return i.error("Failed to initialize framework:", e), this.currentFramework = this.createNoneFramework(), this.initialized = !0, this.currentFramework;
    }
  }
  // 获取当前框架
  getCurrentFramework() {
    if (!this.currentFramework)
      throw new Error("Framework not initialized");
    return this.currentFramework;
  }
  // 切换框架（用于测试或特定场景）
  async switchFramework(e) {
    return i.info(`Switching framework to: ${e}`), this.currentFramework && await this.currentFramework.cleanup(), e === "plasmo" ? this.currentFramework = new I() : e === "wxt" ? this.currentFramework = new F() : this.currentFramework = this.createNoneFramework(), await this.currentFramework.initialize(), i.info(`Switched to framework: ${this.currentFramework.name} (${this.currentFramework.type})`), this.currentFramework;
  }
  // 创建空框架实现
  createNoneFramework() {
    return {
      type: "none",
      name: "None",
      version: "1.0.0",
      async initialize() {
        i.warn("No browser framework detected");
      },
      isAvailable() {
        return !1;
      },
      getAPI() {
        return null;
      },
      async cleanup() {
      }
    };
  }
  // 清理资源
  async cleanup() {
    this.currentFramework && (await this.currentFramework.cleanup(), this.currentFramework = null), this.initialized = !1, i.info("Framework cleaned up");
  }
};
s(z, "instance");
let q = z;
const b = q.getInstance();
class J {
  constructor(e) {
    s(this, "storage"), s(this, "area");
    try {
      const { Storage: t } = require("@plasmohq/storage");
      this.storage = new t({ area: e === p.LOCAL ? "local" : "sync" }), this.area = e, i.info(`Created Plasmo storage for area: ${e}`);
    } catch (t) {
      throw i.error("Failed to create Plasmo storage:", t), new Error("Plasmo storage not available. Make sure @plasmohq/storage is installed.");
    }
  }
  async getItem(e) {
    try {
      const t = await this.storage.get(e);
      if (t === void 0)
        return null;
      if (typeof t == "string")
        return t;
      try {
        return JSON.stringify(t);
      } catch {
        return String(t);
      }
    } catch (t) {
      return i.error(`Failed to get item ${e}:`, t), null;
    }
  }
  async setItem(e, t) {
    try {
      await this.storage.set(e, t);
    } catch (r) {
      throw i.error(`Failed to set item ${e}:`, r), r;
    }
  }
  async removeItem(e) {
    try {
      await this.storage.remove(e);
    } catch (t) {
      throw i.error(`Failed to remove item ${e}:`, t), t;
    }
  }
  async clear() {
    try {
      await this.storage.clear();
    } catch (e) {
      throw i.error("Failed to clear storage:", e), e;
    }
  }
  async key(e) {
    try {
      const t = await this.storage.getAll();
      return Object.keys(t)[e] || null;
    } catch (t) {
      return i.error(`Failed to get key at index ${e}:`, t), null;
    }
  }
  async getLength() {
    try {
      const e = await this.storage.getAll();
      return Object.keys(e).length;
    } catch (e) {
      return i.error("Failed to get storage length:", e), 0;
    }
  }
  async get(e, t) {
    try {
      const r = await this.getItem(e);
      if (r !== null)
        try {
          return JSON.parse(r);
        } catch {
          return r;
        }
    } catch (r) {
      i.error(`Failed to get item ${e}:`, r);
    }
    return t;
  }
  async set(e, t) {
    try {
      const r = JSON.stringify(t);
      await this.setItem(e, r);
    } catch (r) {
      throw i.error(`Failed to set item ${e}:`, r), r;
    }
  }
  async remove(e) {
    return this.removeItem(e);
  }
  async getAll() {
    try {
      return await this.storage.getAll();
    } catch (e) {
      return i.error("Failed to get all items:", e), {};
    }
  }
}
class K {
  createStorage(e) {
    return new J(e);
  }
  isAvailable() {
    try {
      return require("@plasmohq/storage"), !0;
    } catch (e) {
      return i.warn("@plasmohq/storage not available:", e), !1;
    }
  }
}
class j {
  constructor(e) {
    s(this, "storage");
    try {
      if (!chrome || !chrome.storage)
        throw new Error("Chrome storage API not available");
      this.storage = e === p.LOCAL ? chrome.storage.local : chrome.storage.sync, i.info(`Created WXT storage for area: ${e}`);
    } catch (t) {
      throw i.error("Failed to create WXT storage:", t), new Error("WXT storage not available. Make sure chrome.storage API is accessible.");
    }
  }
  async getItem(e) {
    try {
      return new Promise((t, r) => {
        this.storage.get(e, (o) => {
          var a;
          if ((a = chrome == null ? void 0 : chrome.runtime) != null && a.lastError)
            i.error(`Error getting item ${e}:`, chrome.runtime.lastError), r(chrome.runtime.lastError);
          else {
            const l = o[e];
            if (l === void 0)
              t(null);
            else if (typeof l == "string")
              t(l);
            else
              try {
                t(JSON.stringify(l));
              } catch {
                t(String(l));
              }
          }
        });
      });
    } catch (t) {
      return i.error(`Failed to get item ${e}:`, t), null;
    }
  }
  async setItem(e, t) {
    try {
      return new Promise((r, o) => {
        this.storage.set({ [e]: t }, () => {
          var a;
          (a = chrome == null ? void 0 : chrome.runtime) != null && a.lastError ? (i.error(`Error setting item ${e}:`, chrome.runtime.lastError), o(chrome.runtime.lastError)) : r();
        });
      });
    } catch (r) {
      throw i.error(`Failed to set item ${e}:`, r), r;
    }
  }
  async removeItem(e) {
    try {
      return new Promise((t, r) => {
        this.storage.remove(e, () => {
          var o;
          (o = chrome == null ? void 0 : chrome.runtime) != null && o.lastError ? (i.error(`Error removing item ${e}:`, chrome.runtime.lastError), r(chrome.runtime.lastError)) : t();
        });
      });
    } catch (t) {
      throw i.error(`Failed to remove item ${e}:`, t), t;
    }
  }
  async clear() {
    try {
      return new Promise((e, t) => {
        this.storage.clear(() => {
          var r;
          (r = chrome == null ? void 0 : chrome.runtime) != null && r.lastError ? (i.error("Error clearing storage:", chrome.runtime.lastError), t(chrome.runtime.lastError)) : e();
        });
      });
    } catch (e) {
      throw i.error("Failed to clear storage:", e), e;
    }
  }
  async key(e) {
    try {
      return new Promise((t, r) => {
        this.storage.get(null, (o) => {
          var a;
          if ((a = chrome == null ? void 0 : chrome.runtime) != null && a.lastError)
            i.error("Error getting all items:", chrome.runtime.lastError), r(chrome.runtime.lastError);
          else {
            const l = Object.keys(o);
            t(l[e] || null);
          }
        });
      });
    } catch (t) {
      return i.error(`Failed to get key at index ${e}:`, t), null;
    }
  }
  async getLength() {
    try {
      return new Promise((e, t) => {
        this.storage.get(null, (r) => {
          var o;
          (o = chrome == null ? void 0 : chrome.runtime) != null && o.lastError ? (i.error("Error getting all items:", chrome.runtime.lastError), t(chrome.runtime.lastError)) : e(Object.keys(r).length);
        });
      });
    } catch (e) {
      return i.error("Failed to get storage length:", e), 0;
    }
  }
  async get(e, t) {
    try {
      const r = await this.getItem(e);
      if (r !== null)
        try {
          return JSON.parse(r);
        } catch {
          return r;
        }
    } catch (r) {
      i.error(`Failed to get item ${e}:`, r);
    }
    return t;
  }
  async set(e, t) {
    try {
      const r = JSON.stringify(t);
      await this.setItem(e, r);
    } catch (r) {
      throw i.error(`Failed to set item ${e}:`, r), r;
    }
  }
  async remove(e) {
    return this.removeItem(e);
  }
  async getAll() {
    try {
      return new Promise((e, t) => {
        this.storage.get(null, (r) => {
          var o;
          (o = chrome == null ? void 0 : chrome.runtime) != null && o.lastError ? (i.error("Error getting all items:", chrome.runtime.lastError), t(chrome.runtime.lastError)) : e(r);
        });
      });
    } catch (e) {
      return i.error("Failed to get all items:", e), {};
    }
  }
}
class B {
  createStorage(e) {
    return new j(e);
  }
  isAvailable() {
    try {
      return typeof chrome < "u" && !!chrome.storage;
    } catch (e) {
      return i.warn("Chrome storage not available:", e), !1;
    }
  }
}
var p = /* @__PURE__ */ ((n) => (n.LOCAL = "local", n.SYNC = "sync", n.SESSION = "session", n))(p || {});
class H {
  constructor(e) {
    s(this, "storage"), s(this, "area"), e === "session" ? this.storage = sessionStorage : this.storage = localStorage, this.area = e, i.info(`Created native storage for area: ${e}`);
  }
  async getItem(e) {
    try {
      return this.storage.getItem(e);
    } catch (t) {
      return i.error(`Failed to get item ${e}:`, t), null;
    }
  }
  async setItem(e, t) {
    try {
      this.storage.setItem(e, t);
    } catch (r) {
      throw i.error(`Failed to set item ${e}:`, r), r;
    }
  }
  async removeItem(e) {
    try {
      this.storage.removeItem(e);
    } catch (t) {
      throw i.error(`Failed to remove item ${e}:`, t), t;
    }
  }
  async clear() {
    try {
      this.storage.clear();
    } catch (e) {
      throw i.error("Failed to clear storage:", e), e;
    }
  }
  async key(e) {
    try {
      return this.storage.key(e);
    } catch (t) {
      return i.error(`Failed to get key at index ${e}:`, t), null;
    }
  }
  async getLength() {
    try {
      return this.storage.length;
    } catch (e) {
      return i.error("Failed to get storage length:", e), 0;
    }
  }
  async get(e, t) {
    try {
      const r = await this.getItem(e);
      if (r !== null)
        try {
          return JSON.parse(r);
        } catch {
          return r;
        }
    } catch (r) {
      i.error(`Failed to get item ${e}:`, r);
    }
    return t;
  }
  async set(e, t) {
    try {
      const r = JSON.stringify(t);
      await this.setItem(e, r);
    } catch (r) {
      throw i.error(`Failed to set item ${e}:`, r), r;
    }
  }
  async remove(e) {
    return this.removeItem(e);
  }
  async getAll() {
    try {
      const e = {};
      for (let t = 0; t < this.storage.length; t++) {
        const r = this.storage.key(t);
        if (r) {
          const o = this.storage.getItem(r);
          if (o)
            try {
              e[r] = JSON.parse(o);
            } catch {
              e[r] = o;
            }
        }
      }
      return e;
    } catch (e) {
      return i.error("Failed to get all items:", e), {};
    }
  }
}
class v {
  createStorage(e) {
    return new H(e);
  }
  isAvailable() {
    return typeof localStorage < "u" || typeof sessionStorage < "u";
  }
}
const P = class d {
  constructor() {
    s(this, "storageInstances", /* @__PURE__ */ new Map()), s(this, "storageFactory", null), s(this, "initialized", !1);
  }
  static getInstance() {
    return d.instance || (d.instance = new d()), d.instance;
  }
  // 初始化存储管理器
  async initialize() {
    if (!this.initialized)
      try {
        i.info("Initializing storage manager...");
        const e = await b.initialize();
        if (e.type === "plasmo" ? (this.storageFactory = new K(), this.storageFactory.isAvailable() || (i.warn("Plasmo storage not available, falling back to native storage"), this.storageFactory = new v())) : e.type === "wxt" ? (this.storageFactory = new B(), this.storageFactory.isAvailable() || (i.warn("WXT storage not available, falling back to native storage"), this.storageFactory = new v())) : (i.info("Using native storage for current framework"), this.storageFactory = new v()), !this.storageFactory || !this.storageFactory.isAvailable())
          throw new Error("Storage factory not available");
        this.initialized = !0, i.info("Storage manager initialized successfully");
      } catch (e) {
        throw i.error("Failed to initialize storage manager:", e), e;
      }
  }
  // 获取存储实例
  async getStorage(e = "local") {
    if (this.initialized || await this.initialize(), !this.storageFactory)
      throw new Error("Storage factory not initialized");
    if (!this.storageInstances.has(e)) {
      const t = this.storageFactory.createStorage(e);
      this.storageInstances.set(e, t), i.info(`Created storage instance for area: ${e}`);
    }
    return this.storageInstances.get(e);
  }
  // 清理资源
  async cleanup() {
    this.storageInstances.clear(), this.storageFactory = null, this.initialized = !1, i.info("Storage manager cleaned up");
  }
};
s(P, "instance");
let D = P;
const G = D.getInstance();
async function V(n = "local") {
  return G.getStorage(n);
}
class Y {
  constructor() {
    s(this, "handlers", /* @__PURE__ */ new Map()), s(this, "initialized", !1);
  }
  async initialize() {
    if (!this.initialized)
      try {
        i.info("Initializing Plasmo messaging..."), this.isExtensionEnvironment() || i.warn("Not in extension environment, messaging may be limited"), this.initializeMessageListener(), this.initialized = !0, i.info("Plasmo messaging initialized successfully");
      } catch (e) {
        throw i.error("Failed to initialize Plasmo messaging:", e), e;
      }
  }
  async sendMessage(e, t) {
    try {
      if (typeof chrome > "u" || !chrome.runtime)
        throw new Error("Chrome runtime not available");
      return new Promise((r, o) => {
        chrome.runtime.sendMessage(e, (a) => {
          chrome.runtime.lastError ? (i.error("Error sending message:", chrome.runtime.lastError), o(chrome.runtime.lastError)) : r(a);
        });
      });
    } catch (r) {
      throw i.error("Failed to send message:", r), r;
    }
  }
  async sendMessageToBackground(e) {
    return this.sendMessage(e);
  }
  async sendMessageToContent(e, t) {
    try {
      if (typeof chrome > "u" || !chrome.tabs)
        throw new Error("Chrome tabs API not available");
      return new Promise((r, o) => {
        chrome.tabs.sendMessage(t, e, (a) => {
          chrome.runtime.lastError ? (i.error("Error sending message to content:", chrome.runtime.lastError), o(chrome.runtime.lastError)) : r(a);
        });
      });
    } catch (r) {
      throw i.error("Failed to send message to content:", r), r;
    }
  }
  registerHandler(e, t) {
    this.handlers.set(e, t), i.info(`Registered message handler for type: ${e}`);
  }
  unregisterHandler(e) {
    this.handlers.delete(e), i.info(`Unregistered message handler for type: ${e}`);
  }
  async cleanup() {
    try {
      i.info("Cleaning up Plasmo messaging..."), this.handlers.clear(), this.removeMessageListener(), this.initialized = !1, i.info("Plasmo messaging cleaned up successfully");
    } catch (e) {
      i.error("Failed to cleanup Plasmo messaging:", e);
    }
  }
  isExtensionEnvironment() {
    return typeof chrome < "u" && chrome.runtime && chrome.runtime.id;
  }
  initializeMessageListener() {
    !this.isExtensionEnvironment() || !chrome.runtime || (chrome.runtime.onMessage.addListener(this.messageListener.bind(this)), chrome.tabs);
  }
  removeMessageListener() {
    !this.isExtensionEnvironment() || !chrome.runtime || chrome.runtime.onMessage.removeListener(this.messageListener.bind(this));
  }
  async messageListener(e, t, r) {
    try {
      if (i.debug("Received message:", e.type, "from:", t), !e.type)
        return i.warn("Message without type received:", e), r({ error: "Message type required" }), !0;
      const o = this.handlers.get(e.type);
      if (o)
        try {
          const a = await o(e, t);
          r(a);
        } catch (a) {
          i.error(`Error in message handler for ${e.type}:`, a), r({ error: a.message });
        }
      else
        i.warn(`No handler found for message type: ${e.type}`), r({ error: "No handler found" });
    } catch (o) {
      i.error("Error in message listener:", o), r({ error: "Internal error" });
    }
    return !0;
  }
}
const x = class f {
  constructor() {
    s(this, "messaging", null), s(this, "initialized", !1);
  }
  static getInstance() {
    return f.instance || (f.instance = new f()), f.instance;
  }
  // 初始化消息传递管理器
  async initialize() {
    if (!this.initialized)
      try {
        if (i.info("Initializing messaging manager..."), (await b.initialize()).type === "plasmo")
          this.messaging = new Y();
        else
          throw i.warn("No messaging implementation for current framework"), new Error("No messaging implementation available");
        this.messaging && await this.messaging.initialize(), this.initialized = !0, i.info("Messaging manager initialized successfully");
      } catch (e) {
        throw i.error("Failed to initialize messaging manager:", e), e;
      }
  }
  // 获取消息传递实例
  async getMessaging() {
    if (this.initialized || await this.initialize(), !this.messaging)
      throw new Error("Messaging not initialized");
    return this.messaging;
  }
  // 发送消息
  async sendMessage(e, t) {
    return (await this.getMessaging()).sendMessage(e, t);
  }
  // 发送消息到后台
  async sendMessageToBackground(e) {
    return (await this.getMessaging()).sendMessageToBackground(e);
  }
  // 发送消息到内容脚本
  async sendMessageToContent(e, t) {
    return (await this.getMessaging()).sendMessageToContent(e, t);
  }
  // 注册消息处理器
  async registerHandler(e, t) {
    (await this.getMessaging()).registerHandler(e, t);
  }
  // 注销消息处理器
  async unregisterHandler(e) {
    (await this.getMessaging()).unregisterHandler(e);
  }
  // 清理资源
  async cleanup() {
    this.messaging && (await this.messaging.cleanup(), this.messaging = null), this.initialized = !1, i.info("Messaging manager cleaned up");
  }
};
s(x, "instance");
let Q = x;
Q.getInstance();
class Z {
  constructor() {
    s(this, "initialized", !1), s(this, "tabListeners", []), s(this, "tabUpdatedListeners", []), s(this, "tabRemovedListeners", []), s(this, "tabActivatedListeners", []), s(this, "windowListeners", []), s(this, "windowRemovedListeners", []);
  }
  async initialize() {
    if (!this.initialized)
      try {
        if (i.info("Initializing Plasmo runtime..."), !this.isExtensionEnvironment())
          throw new Error("Not in extension environment");
        this.initializeEventListeners(), this.initialized = !0, i.info("Plasmo runtime initialized successfully");
      } catch (e) {
        throw i.error("Failed to initialize Plasmo runtime:", e), e;
      }
  }
  async getTabs() {
    try {
      if (!this.isExtensionEnvironment() || !chrome.tabs)
        throw new Error("Chrome tabs API not available");
      return new Promise((e, t) => {
        chrome.tabs.query({}, (r) => {
          if (chrome.runtime.lastError)
            i.error("Error getting tabs:", chrome.runtime.lastError), t(chrome.runtime.lastError);
          else {
            const o = r.map(this.convertToTabInfo.bind(this));
            e(o);
          }
        });
      });
    } catch (e) {
      throw i.error("Failed to get tabs:", e), e;
    }
  }
  async getTab(e) {
    try {
      if (!this.isExtensionEnvironment() || !chrome.tabs)
        throw new Error("Chrome tabs API not available");
      return new Promise((t, r) => {
        chrome.tabs.get(e, (o) => {
          chrome.runtime.lastError ? (i.error(`Error getting tab ${e}:`, chrome.runtime.lastError), t(null)) : t(this.convertToTabInfo(o));
        });
      });
    } catch (t) {
      return i.error(`Failed to get tab ${e}:`, t), null;
    }
  }
  async createTab(e, t) {
    try {
      if (!this.isExtensionEnvironment() || !chrome.tabs)
        throw new Error("Chrome tabs API not available");
      return new Promise((r, o) => {
        const a = {
          url: e,
          active: (t == null ? void 0 : t.active) ?? !0
        };
        t != null && t.windowId && (a.windowId = t.windowId), chrome.tabs.create(a, (l) => {
          chrome.runtime.lastError ? (i.error("Error creating tab:", chrome.runtime.lastError), o(chrome.runtime.lastError)) : r(this.convertToTabInfo(l));
        });
      });
    } catch (r) {
      throw i.error("Failed to create tab:", r), r;
    }
  }
  async updateTab(e, t) {
    try {
      if (!this.isExtensionEnvironment() || !chrome.tabs)
        throw new Error("Chrome tabs API not available");
      return new Promise((r, o) => {
        const a = {};
        t.url !== void 0 && (a.url = t.url), t.active !== void 0 && (a.active = t.active), t.title !== void 0 && i.warn("Cannot directly update tab title through tabs API"), chrome.tabs.update(e, a, (l) => {
          chrome.runtime.lastError ? (i.error(`Error updating tab ${e}:`, chrome.runtime.lastError), o(chrome.runtime.lastError)) : r(this.convertToTabInfo(l));
        });
      });
    } catch (r) {
      throw i.error(`Failed to update tab ${e}:`, r), r;
    }
  }
  async removeTab(e) {
    try {
      if (!this.isExtensionEnvironment() || !chrome.tabs)
        throw new Error("Chrome tabs API not available");
      return new Promise((t, r) => {
        chrome.tabs.remove(e, () => {
          chrome.runtime.lastError ? (i.error(`Error removing tab ${e}:`, chrome.runtime.lastError), r(chrome.runtime.lastError)) : t();
        });
      });
    } catch (t) {
      throw i.error(`Failed to remove tab ${e}:`, t), t;
    }
  }
  async getWindows() {
    try {
      if (!this.isExtensionEnvironment() || !chrome.windows)
        throw new Error("Chrome windows API not available");
      return new Promise((e, t) => {
        chrome.windows.getAll({ populate: !0 }, (r) => {
          if (chrome.runtime.lastError)
            i.error("Error getting windows:", chrome.runtime.lastError), t(chrome.runtime.lastError);
          else {
            const o = r.map(this.convertToWindowInfo.bind(this));
            e(o);
          }
        });
      });
    } catch (e) {
      throw i.error("Failed to get windows:", e), e;
    }
  }
  async getWindow(e) {
    try {
      if (!this.isExtensionEnvironment() || !chrome.windows)
        throw new Error("Chrome windows API not available");
      return new Promise((t, r) => {
        chrome.windows.get(e, { populate: !0 }, (o) => {
          chrome.runtime.lastError ? (i.error(`Error getting window ${e}:`, chrome.runtime.lastError), t(null)) : t(this.convertToWindowInfo(o));
        });
      });
    } catch (t) {
      return i.error(`Failed to get window ${e}:`, t), null;
    }
  }
  async createWindow(e, t) {
    try {
      if (!this.isExtensionEnvironment() || !chrome.windows)
        throw new Error("Chrome windows API not available");
      return new Promise((r, o) => {
        const a = {
          url: e,
          focused: (t == null ? void 0 : t.focused) ?? !0,
          type: (t == null ? void 0 : t.type) ?? "normal"
        };
        chrome.windows.create(a, (l) => {
          chrome.runtime.lastError ? (i.error("Error creating window:", chrome.runtime.lastError), o(chrome.runtime.lastError)) : chrome.windows.get(l.id, { populate: !0 }, (u) => {
            chrome.runtime.lastError ? (i.error("Error getting populated window:", chrome.runtime.lastError), o(chrome.runtime.lastError)) : r(this.convertToWindowInfo(u));
          });
        });
      });
    } catch (r) {
      throw i.error("Failed to create window:", r), r;
    }
  }
  async updateWindow(e, t) {
    try {
      if (!this.isExtensionEnvironment() || !chrome.windows)
        throw new Error("Chrome windows API not available");
      return new Promise((r, o) => {
        const a = {};
        t.focused !== void 0 && (a.focused = t.focused), chrome.windows.update(e, a, (l) => {
          chrome.runtime.lastError ? (i.error(`Error updating window ${e}:`, chrome.runtime.lastError), o(chrome.runtime.lastError)) : chrome.windows.get(l.id, { populate: !0 }, (u) => {
            chrome.runtime.lastError ? (i.error("Error getting populated window:", chrome.runtime.lastError), o(chrome.runtime.lastError)) : r(this.convertToWindowInfo(u));
          });
        });
      });
    } catch (r) {
      throw i.error(`Failed to update window ${e}:`, r), r;
    }
  }
  async removeWindow(e) {
    try {
      if (!this.isExtensionEnvironment() || !chrome.windows)
        throw new Error("Chrome windows API not available");
      return new Promise((t, r) => {
        chrome.windows.remove(e, () => {
          chrome.runtime.lastError ? (i.error(`Error removing window ${e}:`, chrome.runtime.lastError), r(chrome.runtime.lastError)) : t();
        });
      });
    } catch (t) {
      throw i.error(`Failed to remove window ${e}:`, t), t;
    }
  }
  async getExtensionInfo() {
    try {
      if (!this.isExtensionEnvironment() || !chrome.runtime)
        throw new Error("Chrome runtime API not available");
      return {
        id: chrome.runtime.id || "",
        name: chrome.runtime.getManifest().name || "",
        version: chrome.runtime.getManifest().version || ""
      };
    } catch (e) {
      throw i.error("Failed to get extension info:", e), e;
    }
  }
  getExtensionURL(e) {
    try {
      if (!this.isExtensionEnvironment() || !chrome.runtime)
        throw new Error("Chrome runtime API not available");
      return chrome.runtime.getURL(e);
    } catch (t) {
      throw i.error("Failed to get extension URL:", t), t;
    }
  }
  onTabCreated(e) {
    this.tabListeners.push(e);
  }
  onTabUpdated(e) {
    this.tabUpdatedListeners.push(e);
  }
  onTabRemoved(e) {
    this.tabRemovedListeners.push(e);
  }
  onWindowCreated(e) {
    this.windowListeners.push(e);
  }
  onWindowRemoved(e) {
    this.windowRemovedListeners.push(e);
  }
  onTabActivated(e) {
    this.tabActivatedListeners.push(e);
  }
  async executeScript(e, t) {
    try {
      if (!this.isExtensionEnvironment() || !chrome.tabs)
        throw new Error("Chrome tabs API not available");
      return new Promise((r, o) => {
        chrome.tabs.executeScript(e, t, (a) => {
          chrome.runtime.lastError ? (i.error("Error executing script:", chrome.runtime.lastError), o(chrome.runtime.lastError)) : r(a && a.length > 0 ? a[0] : null);
        });
      });
    } catch (r) {
      throw i.error("Failed to execute script:", r), r;
    }
  }
  async cleanup() {
    try {
      i.info("Cleaning up Plasmo runtime..."), this.tabListeners = [], this.tabUpdatedListeners = [], this.tabRemovedListeners = [], this.tabActivatedListeners = [], this.windowListeners = [], this.windowRemovedListeners = [], this.initialized = !1, i.info("Plasmo runtime cleaned up successfully");
    } catch (e) {
      i.error("Failed to cleanup Plasmo runtime:", e);
    }
  }
  isExtensionEnvironment() {
    return typeof chrome < "u" && chrome.runtime && chrome.runtime.id;
  }
  initializeEventListeners() {
    this.isExtensionEnvironment() && (chrome.tabs && chrome.tabs.onCreated && chrome.tabs.onCreated.addListener((e) => {
      const t = this.convertToTabInfo(e);
      this.tabListeners.forEach((r) => r(t));
    }), chrome.tabs && chrome.tabs.onUpdated && chrome.tabs.onUpdated.addListener((e, t) => {
      const r = {};
      t.url && (r.url = t.url), t.title && (r.title = t.title), t.active !== void 0 && (r.active = t.active), this.tabUpdatedListeners.forEach((o) => o(e, r));
    }), chrome.tabs && chrome.tabs.onRemoved && chrome.tabs.onRemoved.addListener((e) => {
      this.tabRemovedListeners.forEach((t) => t(e));
    }), chrome.tabs && chrome.tabs.onActivated && chrome.tabs.onActivated.addListener((e) => {
      this.tabActivatedListeners.forEach((t) => t(e.tabId, e.windowId));
    }), chrome.windows && chrome.windows.onCreated && chrome.windows.onCreated.addListener((e) => {
      chrome.windows && chrome.windows.get(e.id, { populate: !0 }, (t) => {
        if (!chrome.runtime.lastError) {
          const r = this.convertToWindowInfo(t);
          this.windowListeners.forEach((o) => o(r));
        }
      });
    }), chrome.windows && chrome.windows.onRemoved && chrome.windows.onRemoved.addListener((e) => {
      this.windowRemovedListeners.forEach((t) => t(e));
    }));
  }
  convertToTabInfo(e) {
    return {
      id: e.id || 0,
      url: e.url || "",
      title: e.title || "",
      active: e.active || !1,
      windowId: e.windowId || 0
    };
  }
  convertToWindowInfo(e) {
    return {
      id: e.id || 0,
      tabs: e.tabs ? e.tabs.map(this.convertToTabInfo.bind(this)) : [],
      focused: e.focused || !1,
      type: e.type || "normal"
    };
  }
}
const T = class y {
  constructor() {
    s(this, "runtime", null), s(this, "initialized", !1);
  }
  static getInstance() {
    return y.instance || (y.instance = new y()), y.instance;
  }
  // 初始化运行时管理器
  async initialize() {
    if (!this.initialized)
      try {
        if (i.info("Initializing runtime manager..."), (await b.initialize()).type === "plasmo")
          this.runtime = new Z();
        else
          throw i.warn("No runtime implementation for current framework"), new Error("No runtime implementation available");
        this.runtime && await this.runtime.initialize(), this.initialized = !0, i.info("Runtime manager initialized successfully");
      } catch (e) {
        throw i.error("Failed to initialize runtime manager:", e), e;
      }
  }
  // 获取运行时实例
  async getRuntime() {
    if (this.initialized || await this.initialize(), !this.runtime)
      throw new Error("Runtime not initialized");
    return this.runtime;
  }
  // 便捷方法：标签页管理
  async getTabs() {
    return (await this.getRuntime()).getTabs();
  }
  async getTab(e) {
    return (await this.getRuntime()).getTab(e);
  }
  async createTab(e, t) {
    return (await this.getRuntime()).createTab(e, t);
  }
  async updateTab(e, t) {
    return (await this.getRuntime()).updateTab(e, t);
  }
  async removeTab(e) {
    return (await this.getRuntime()).removeTab(e);
  }
  // 便捷方法：窗口管理
  async getWindows() {
    return (await this.getRuntime()).getWindows();
  }
  async getWindow(e) {
    return (await this.getRuntime()).getWindow(e);
  }
  async createWindow(e, t) {
    return (await this.getRuntime()).createWindow(e, t);
  }
  async updateWindow(e, t) {
    return (await this.getRuntime()).updateWindow(e, t);
  }
  async removeWindow(e) {
    return (await this.getRuntime()).removeWindow(e);
  }
  // 便捷方法：扩展信息
  async getExtensionInfo() {
    return (await this.getRuntime()).getExtensionInfo();
  }
  getExtensionURL(e) {
    if (!this.runtime)
      throw new Error("Runtime not initialized");
    return this.runtime.getExtensionURL(e);
  }
  // 脚本执行
  async executeScript(e, t) {
    return (await this.getRuntime()).executeScript(e, t);
  }
  // 清理资源
  async cleanup() {
    this.runtime && (await this.runtime.cleanup(), this.runtime = null), this.initialized = !1, i.info("Runtime manager cleaned up");
  }
};
s(T, "instance");
let _ = T;
const E = _.getInstance(), { getTabs: ae, getTab: se, createTab: ce, updateTab: le, removeTab: me, executeScript: he } = E, { getWindows: ue, getWindow: ge, createWindow: we, updateWindow: de, removeWindow: fe } = E, { getExtensionInfo: ye, getExtensionURL: pe } = E;
class ee {
  constructor(e) {
    g(this, "storage");
    g(this, "appId");
    if (typeof window < "u")
      this.storage = localStorage, this.appId = e;
    else
      throw new Error("BrowserStorage not available in this environment");
  }
  getPrefixedKey(e) {
    return this.appId ? `${this.appId}_${e}` : e;
  }
  getItem(e) {
    return this.storage.getItem(this.getPrefixedKey(e));
  }
  setItem(e, t) {
    this.storage.setItem(this.getPrefixedKey(e), t);
  }
  removeItem(e) {
    this.storage.removeItem(this.getPrefixedKey(e));
  }
  clear() {
    this.storage.clear();
  }
  key(e) {
    return this.storage.key(e);
  }
  getLength() {
    return this.storage.length;
  }
  async get(e, t) {
    try {
      const r = this.getItem(e);
      if (r !== null)
        try {
          return JSON.parse(r);
        } catch {
          return r;
        }
    } catch (r) {
      console.error(`Failed to get item ${e}:`, r);
    }
    return t;
  }
  async set(e, t) {
    try {
      const r = JSON.stringify(t);
      this.setItem(e, r);
    } catch (r) {
      throw console.error(`Failed to set item ${e}:`, r), r;
    }
  }
  async remove(e) {
    try {
      this.removeItem(e);
    } catch (t) {
      throw console.error(`Failed to remove item ${e}:`, t), t;
    }
  }
}
const c = class c {
  static configure(e) {
    c.appId = e, c.instance = null;
  }
  static async getInstance() {
    if (!c.instance)
      try {
        const e = await V(p.LOCAL), t = {
          async getItem(r) {
            const o = c.appId ? `${c.appId}_${r}` : r;
            return await e.getItem(o);
          },
          async setItem(r, o) {
            const a = c.appId ? `${c.appId}_${r}` : r;
            await e.setItem(a, o);
          },
          async removeItem(r) {
            const o = c.appId ? `${c.appId}_${r}` : r;
            await e.removeItem(o);
          },
          async clear() {
            if (c.appId) {
              const r = await e.getAll();
              for (const o in r)
                o.startsWith(`${c.appId}_`) && await e.removeItem(o);
            } else
              await e.clear();
          },
          async key(r) {
            const o = await e.getAll(), a = Object.keys(o);
            return (c.appId ? a.filter((u) => u.startsWith(`${c.appId}_`)) : a)[r] || null;
          },
          async getLength() {
            const r = await e.getAll(), o = Object.keys(r);
            return (c.appId ? o.filter((l) => l.startsWith(`${c.appId}_`)) : o).length;
          },
          async get(r, o) {
            const a = c.appId ? `${c.appId}_${r}` : r;
            return await e.get(a, o);
          },
          async set(r, o) {
            const a = c.appId ? `${c.appId}_${r}` : r;
            await e.set(a, o);
          },
          async remove(r) {
            const o = c.appId ? `${c.appId}_${r}` : r;
            await e.remove(o);
          }
        };
        c.instance = t;
      } catch {
        try {
          const t = new ee(c.appId);
          c.instance = t;
        } catch {
          throw new Error("No suitable storage implementation found for this environment");
        }
      }
    return c.instance;
  }
};
g(c, "instance", null), g(c, "appId");
let m = c;
async function te(n, e) {
  try {
    const r = await (await m.getInstance()).getItem(n);
    if (r !== null)
      try {
        return JSON.parse(r);
      } catch {
        return r;
      }
  } catch (t) {
    console.error(`Failed to get item ${n}:`, t);
  }
  return e;
}
async function re(n, e) {
  try {
    const t = await m.getInstance(), r = JSON.stringify(e);
    await t.setItem(n, r);
  } catch (t) {
    throw console.error(`Failed to set item ${n}:`, t), t;
  }
}
async function ie(n) {
  try {
    await (await m.getInstance()).removeItem(n);
  } catch (e) {
    throw console.error(`Failed to remove item ${n}:`, e), e;
  }
}
const ve = () => m.getInstance(), be = async (n) => (await m.getInstance()).getItem(n), Ee = async (n, e) => (await m.getInstance()).setItem(n, e), Ie = async (n) => (await m.getInstance()).removeItem(n), Fe = async () => (await m.getInstance()).clear(), ke = async (n) => (await m.getInstance()).key(n), ze = async () => (await m.getInstance()).getLength(), ne = new Proxy({
  // 基础存储方法代理
  getItem: async (n) => (await m.getInstance()).getItem(n),
  setItem: async (n, e) => (await m.getInstance()).setItem(n, e),
  removeItem: async (n) => (await m.getInstance()).removeItem(n),
  clear: async () => (await m.getInstance()).clear(),
  key: async (n) => (await m.getInstance()).key(n),
  getLength: async () => (await m.getInstance()).getLength(),
  // 便捷方法
  get: te,
  set: re,
  remove: ie
}, {
  // 确保直接调用实例方法时也使用最新实例
  get(n, e, t) {
    return e in n ? Reflect.get(n, e, t) : async (...r) => (await m.getInstance())[e](...r);
  }
}), Pe = ne, xe = (n) => {
  m.configure(n);
};
export {
  Fe as clear,
  xe as configureStorage,
  ne as default,
  te as get,
  be as getItem,
  ze as getLength,
  ve as getStorageInstance,
  ke as key,
  ie as remove,
  Ie as removeItem,
  re as set,
  Ee as setItem,
  Pe as storage
};
